import { createTag as _createTag } from '@griply/services';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { NewTag } from 'shared/types/tag';

import { getAuthentication, getDatabase } from './helpers';

export const createTag = async (tag: NewTag) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return _createTag({
    tag,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.CreateTag,
        error,
        uid: user.uid,
      }),
  });
};
